/* AAC load-more-on-scroll for collection grids (2026-09-24).
   Collections render 48 products per page with normal pagination links (kept in the page for crawlers and no-JS visitors).
   When a shopper nears the end of the grid, the next page's product cards are fetched as a section render and appended.
   New cards get Empire's lazy images via 'theme:rimg:watch' and quick shop / add-to-cart via 'aac:productgrid:appended'. */
(function () {
  var grid = document.querySelector('[data-productgrid-items]');
  if (!grid) return;
  var nav = document.querySelector('.pagination--container');
  var nextHref = function () { var a = nav && nav.querySelector('.pagination--next a'); return a ? a.getAttribute('href') : null; };
  if (!nextHref()) return;
  var sectionEl = grid.closest('.shopify-section');
  var idEl = sectionEl && sectionEl.querySelector('[data-section-id]');
  var sectionId = idEl ? idEl.getAttribute('data-section-id') : null;

  nav.classList.add('aac-pagination--auto');
  var status = document.createElement('div');
  status.className = 'aac-loadmore';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  var button = document.createElement('button');
  button.type = 'button';
  button.className = 'aac-loadmore__button button-secondary';
  button.textContent = 'Load more cigars';
  status.appendChild(button);
  nav.parentNode.insertBefore(status, nav);

  var loading = false, failures = 0, observer = null;

  function finish() {
    if (observer) observer.disconnect();
    if (nav && nav.parentNode) nav.parentNode.removeChild(nav);
    nav = null;
    status.parentNode && status.parentNode.removeChild(status);
  }

  function loadNext() {
    var href = nextHref();
    if (!href) { finish(); return; }
    if (loading) return;
    loading = true;
    button.disabled = true;
    button.textContent = 'Loading more cigars…';
    var url = new URL(href, window.location.origin);
    if (sectionId) url.searchParams.set('section_id', sectionId);
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('[data-productgrid-items] > [data-product-item]');
        var frag = document.createDocumentFragment();
        for (var i = 0; i < items.length; i++) frag.appendChild(document.importNode(items[i], true));
        grid.appendChild(frag);
        grid.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
        grid.dispatchEvent(new CustomEvent('aac:productgrid:appended', { bubbles: true }));
        var newNav = doc.querySelector('.pagination--container');
        if (newNav && newNav.querySelector('.pagination--next a')) {
          newNav.classList.add('aac-pagination--auto');
          nav.parentNode.replaceChild(document.importNode(newNav, true), nav);
          nav = document.querySelector('.pagination--container');
          failures = 0;
          loading = false;
          button.disabled = false;
          button.textContent = 'Load more cigars';
        } else {
          loading = false;
          finish();
        }
      })
      .catch(function () {
        loading = false;
        failures++;
        button.disabled = false;
        button.textContent = 'Load more cigars';
        if (failures >= 2 && observer) observer.disconnect();
      });
  }

  button.addEventListener('click', loadNext);
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadNext();
    }, { rootMargin: '0px 0px 900px 0px' });
    observer.observe(status);
  }
})();
